import { defineComponent as _defineComponent } from 'vue';
import Draggable from "./Draggable.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DraggablePan',
    props: {
        rootOffset: {
            type: Object,
            required: true,
        },
        position: {
            type: Object,
            default: null,
        },
        scale: {
            type: Number,
            required: false,
            default: 1,
        },
        preventDefault: {
            type: Boolean,
            default: true,
        },
        stopPropagation: {
            type: Boolean,
            default: true,
        },
        dragData: {
            type: Object,
            required: false,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        panMargin: {
            type: Number,
            default: 60,
        },
        snappable: {
            type: Boolean,
            default: true,
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["pan-by", "move", "mouseup", "mousedown", "start"],
    setup(__props, { emit }) {
        const props = __props;
        let isPanning = false;
        const panBy = { x: 0, y: 0 };
        let movePosition = {
            x: 0,
            y: 0,
            unscaled: {
                x: 0,
                y: 0,
            },
        };
        let previousTimestamp;
        function pan(timestamp) {
            if (isPanning) {
                if (!previousTimestamp) {
                    previousTimestamp = timestamp;
                }
                const deltaTime = (timestamp - previousTimestamp) / 1000;
                const scaledPan = { x: panBy.x * deltaTime, y: panBy.y * deltaTime };
                emit("pan-by", scaledPan);
                // we need to move in the opposite direction of the pan
                movePosition.x -= scaledPan.x;
                movePosition.y -= scaledPan.y;
                emit("move", movePosition);
                previousTimestamp = timestamp;
                requestAnimationFrame(pan);
            }
            else {
                previousTimestamp = undefined;
            }
        }
        const panSpeedFactor = 6;
        function onMove(position, event) {
            let doPan = false;
            panBy.x = 0;
            panBy.y = 0;
            const deltaSpeed = (delta) => {
                const scaledDelta = Math.abs((delta * panSpeedFactor) / props.scale);
                const clampedDelta = Math.min(scaledDelta, 1200 / props.scale);
                return clampedDelta;
            };
            const deltaLeft = event.pageX - props.rootOffset.left - props.panMargin;
            const deltaRight = props.rootOffset.right - event.pageX - props.panMargin;
            const deltaTop = event.pageY - props.rootOffset.top - props.panMargin;
            const deltaBottom = props.rootOffset.bottom - event.pageY - props.panMargin;
            if (deltaLeft < 0) {
                panBy.x = deltaSpeed(deltaLeft);
                doPan = true;
            }
            if (deltaTop < 0) {
                panBy.y = deltaSpeed(deltaTop);
                doPan = true;
            }
            if (deltaRight < 0) {
                panBy.x = -deltaSpeed(deltaRight);
                doPan = true;
            }
            if (deltaBottom < 0) {
                panBy.y = -deltaSpeed(deltaBottom);
                doPan = true;
            }
            movePosition = { ...position };
            if (!doPan) {
                emit("move", position, event);
                isPanning = false;
            }
            if (doPan && !isPanning) {
                isPanning = true;
                requestAnimationFrame(pan);
            }
        }
        function onMouseUp(e) {
            isPanning = false;
            emit("mouseup", e);
        }
        function onStart() {
            emit("start");
        }
        return { __sfc: true, props, emit, isPanning, panBy, movePosition, previousTimestamp, pan, panSpeedFactor, onMove, onMouseUp, onStart, Draggable };
    }
});
